module.exports = __webpack_public_path__ + "facebook-new-76f39fe4abe917d263fa.svg";